import React from "react";
import { HomeownerTable } from "../homeowner-table";

export const HomeownerAccountsPage = () => {
  return <HomeownerTable />;
};
